import styled from 'styled-components';
import Stack from 'atoms/Layout/Stack/Stack';
import { cssVar } from 'styles/helper';
import { getDefaultTextStyles } from 'src/functions/articleBodyHelper';

export const ArticleBodyStack = styled(Stack)`
  color: var(--text-tertiary);

  p,
  strong {
    & > .ast-a-element {
      font-size: inherit;
    }
  }

  hr.ast-hr-element {
    height: 1px;
    background-color: ${cssVar('bg-quaternary')};
    border: none;
    margin: ${cssVar('spacing-lg')} 0;
  }

  .ast-strong-element {
    color: ${cssVar('text-primary')};
  }

  .ast-button-element {
    width: auto;
  }

  ul.ast-ul-element,
  ol.ast-ol-element {
    margin-top: 0px;
    margin-bottom: 0px;
    padding-left: 1rem;

    & > span {
      display: none;
    }

    li.ast-li-element {
      margin-bottom: 1rem;
    }
  }

  ul.ast-ul-element {
    list-style-type: disc;
  }

  // TODO MKT-9829: Styles below are the previous version of the article body,
  // we should remove them IF there's a replacement for the HTML Parser AST

  ${getDefaultTextStyles()}

  .attachment-container {
    width: 100%;
    left: 0;
  }

  .iframe-video-container {
    width: 100%;
    left: 0;
    padding: 0;

    > iframe {
      height: 390px;

      @media screen and (max-width: ${cssVar('width-sm')}) {
        height: 300px;
      }

      @media screen and (max-width: ${cssVar('width-xs')}) {
        height: 210px;
      }
    }
  }

  ${getDefaultTextStyles()}

  p.center.ast-p-element {
    text-align: center;
    margin-bottom: 2rem;
  }

  p.ast-p-element {
    font-weight: 300;
    line-height: 1.75rem;
    margin: 0rem;
    -webkit-font-smoothing: antialiased;

    @media all and (max-width: ${cssVar('width-xs')}) {
      font-size: 1rem;
    }
  }

  a.ast-a-element {
    // Changed on Figma
    text-decoration: underline;
    color: ${cssVar('text-brand-secondary')};
    font-weight: 700;

    &.button {
      transition: all 200ms ease-in-out;
      text-decoration: none;
      border-radius: 0.5rem;
      border: 1px solid ${cssVar('text-primary')};
      justify-self: center;
      position: relative;
      top: 0.5rem;
      font-size: 1rem;
      line-height: 1.5rem;
      margin: 0 auto;
      width: fit-content;
      display: block;
      max-height: 43px;
      padding: 10px 14px;
      background-color: #00d0ad;
      background-image: linear-gradient(180deg, #00d0ad 0%, #bdf198 163.64%);
      border: none;
      color: #092b2e;
      box-shadow:
        0px 0px 0px 1px rgba(10, 13, 18, 0.18) inset,
        0px -2px 0px 0px rgba(10, 13, 18, 0.05) inset,
        0px 1px 2px 0px rgba(10, 13, 18, 0.05);

      &:hover {
        background-color: #18b59b;
        background-image: none;
      }

      &:focus {
        box-shadow:
          0px 0px 0px 1px rgba(10, 13, 18, 0.18) inset,
          0px -2px 0px 0px rgba(10, 13, 18, 0.05) inset,
          0px 1px 2px 0px rgba(10, 13, 18, 0.05),
          0px 0px 0px 2px #fff,
          0px 0px 0px 4px #00d0ad;
      }
    }
  }
  h2.ast-h2-element {
    line-height: 1.4;
    margin: 0;
    padding-top: 24px;
    color: ${cssVar('text-primary')};
  }

  h3.ast-h3-element {
    line-height: 1.4;
    margin: 0;
    padding-top: 24px;
    color: ${cssVar('text-primary')};
  }
  h4.ast-h4-element {
    line-height: 1.4;
    margin: 0;
    padding-top: 24px;
    color: ${cssVar('text-primary')};
  }
  h5.ast-h5-element {
    font-size: 1.2em;
    line-height: 1.4;
    margin: 0;
    font-family: ${cssVar('font-family-display')};
    padding-top: 24px;
    color: ${cssVar('text-primary')};
  }
  ul.ast-ul-element {
    margin-bottom: 0px;
    margin-left: 24px;
    list-style-type: disc;
    padding-left: 20px;

    li.ast-li-element {
      margin-bottom: 20px;
      font-weight: 300;
      -webkit-font-smoothing: antialiased;
    }
  }

  ol.ast-ol-element {
    margin-bottom: 0px;
    margin-left: 30px;

    li.ast-li-element {
      margin-bottom: 20px;
      font-weight: 300;
      -webkit-font-smoothing: antialiased;
    }
  }

  strong.ast-strong-element {
    font-weight: 700;
  }

  p.ast-p-element > img.ast-img-element,
  p.ast-p-element > a.ast-a-element > img.ast-img-element {
    width: 100%;
  }

  .table-of-content {
    margin-left: 1rem;

    ul {
      margin: 1rem 0;
      padding: 0;
    }

    li {
      margin-bottom: 0;
      box-sizing: border-box;

      > p {
        font-size: 1.125rem;
        font-weight: bold;
      }
    }

    a {
      font-size: 1.125rem;
      margin-left: 8px;
      font-weight: bold;
    }

    .list-item-1 {
      padding-left: 0.5rem;
      margin-bottom: 0;
    }

    .list-item-2 {
      padding-left: 1.8rem;
      margin-top: -0.5rem;
    }

    .sub-list {
      margin: 0;
    }
  }

  br {
    // Required fixes for Firefox BR tag
    display: block;
    line-height: 0;
    height: 0;
    padding: 0;
    margin: ${cssVar('spacing-2xl')} 0 0 0;
  }

  @media all and (max-width: ${cssVar('width-sm')}) {
    ul.ast-ul-element,
    ol.ast-ol-element {
      margin-left: 0;
    }
  }
`;
